import React, { useEffect } from 'react';
import {useAppDispatch, useAppSelector} from '../../../../../../hooks/hooks';
import {updateShiftsType} from '../../../../../../features/types';
import {TiminatorType} from '../../../../../../features/types/types';
import {Form, Formik} from 'formik';
import * as Yup from 'yup';
import {FormInput} from '../../../../../../components/shared/form-controls/form-input';
import {FormCheckbox} from '../../../../../../components/shared/form-controls/form-checkbox';
import { useLocation, useNavigate } from 'react-router-dom';
import { ShiftType } from '../../../../../../features/shifts/types';
import BaseForm from '../../../../../../components/shared/form-controls/base-form';
import { NAVIGATION_ROUTES } from '../../../../../../routes/NavigationRoute';
import { canManageShiftTypes } from '../../../../../../features/profile/entityPermissions';

interface EditForm {
    name: string;
    isDefault: boolean;
    isActive: boolean;
}

export default function ShiftTypeEditForm() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const profile = useAppSelector(store => store.profile);

    const state = location.state as {shiftType: ShiftType} | undefined;
    const canEditShiftTypes = canManageShiftTypes(profile);

    useEffect(() => {
        if (!state?.shiftType || !canEditShiftTypes) {
            navigate(NAVIGATION_ROUTES.SHIFT_TYPES);
        }
    }, [canEditShiftTypes, navigate, state]);

    const initialValues: EditForm = {
        name: state?.shiftType?.name ?? '',
        isDefault: state?.shiftType?.default ?? false,
        isActive: state?.shiftType?.active ?? false,
    };

    const initialHeader = state?.shiftType?.name ?? '';

    if (!state?.shiftType || !canEditShiftTypes) {
        return null;
    }

    const save = async (values: EditForm) => {
        const type: TiminatorType = {
            id: state?.shiftType?.id ?? 0,
            name: values.name,
            active: values.isActive,
            default: values.isDefault,
        }

        return dispatch(updateShiftsType(type)).unwrap();
    }

    const validationScheme: Yup.Schema<EditForm> = Yup.object({
        name: Yup.string()
            .max(45, 'Must be 45 characters or less')
            .required('Required'),
        isDefault: Yup.boolean().required(),
        isActive: Yup.boolean().required(),
    })

    return <Formik
        initialValues={initialValues}
        validationSchema={validationScheme}
        validateOnChange={true}
        validateOnBlur={true}
        onSubmit={save}>
        <Form>
            <BaseForm contentGap={24}
                formType='edit'
                formHeader='edit_shift_type'
                elementName={initialHeader} 
                savingTitle='Shift type'
                onClose={() => navigate(NAVIGATION_ROUTES.SHIFT_TYPES)}
                onAfterSave={() => navigate(NAVIGATION_ROUTES.SHIFT_TYPES)}>
                <FormInput name='name' label='Name' placeholder='Shift type' />
                <fieldset>
                    <FormCheckbox name='isDefault' label='Default' />
                    <FormCheckbox name='isActive' label='Active'/>
                </fieldset>
            </BaseForm>
        </Form>
    </Formik>
}
